export default "__VITE_ASSET__DVAHuXr___"